export default __webpack_public_path__ + "static/media/home_page_background.ac3d164a.svg";